import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class DataService {

    constructor(
        public http: HttpClient) {
    }

    // Use this function for simple calls with few parameters.
    public get(url: string): Promise<any> {
        return this.http.get(url).toPromise()
            .catch(this.handleError);
    }

    // Use this function for calls with multiple parameters.
    public getWithParams(url: string, params: Map<any, any>): Promise<any> {
        let newParams = new HttpParams();
        params.forEach((value, key) => {
            newParams = newParams.set(key, value);
        });
        return this.http.get(url, {params: newParams}).toPromise()
            .catch(this.handleError);
    }

    public post(url: string, body: any): Promise<any> {
        return this.http.post(url, body).toPromise()
            .catch(this.handleError);
    }

    public put(url: string, body: any): Promise<any> {
        return this.http.put(url, body).toPromise()
            .catch(this.handleError);
    }

    public patch(url: string, body: any): Promise<any> {
        return this.http.patch(url, body).toPromise()
            .catch(this.handleError);
    }

    public delete(url: string, body: any): Promise<any> {
        return this.http.request('DELETE', url, {body: body}).toPromise()
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        return Promise.reject(error);
    }
}
